// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import WalletController from "./wallet_controller"
application.register("wallet", WalletController)

import SplitController from "./split_controller"
application.register("split", SplitController)

import InvestController from "./invest_controller"
application.register("invest", InvestController)

import ApprovalController from "./approval_controller"
application.register("approval", ApprovalController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import DcaCalculatorController from "./dca_calculator_controller"
application.register("forecast", DcaCalculatorController)

import DcaPageController from "./dca_page_controller"
application.register("dca-page", DcaPageController)

import PrivyController from "./privy_controller"
application.register("privy", PrivyController)

import PrivyFundingController from "./privy_funding_controller"
application.register("privy-funding", PrivyFundingController)

import FundingGateController from "./funding_gate_controller"
application.register("funding-gate", FundingGateController)

import FirstBuyController from "./first_buy_controller"
application.register("first-buy", FirstBuyController)

import StockMixController from "./stock_mix_controller"
application.register("stock-mix", StockMixController)

import PacketController from "./packet_controller"
application.register("packet", PacketController)

import PortfolioController from "./portfolio_controller"
application.register("portfolio", PortfolioController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import PlanEditController from "./plan_edit_controller"
application.register("plan-edit", PlanEditController)

import StepsController from "./steps_controller"
import TransferController from "./transfer_controller"
application.register("steps", StepsController)
application.register("transfer", TransferController)

import DailyPlanController from "./daily_plan_controller"
application.register("daily-plan", DailyPlanController)

import CampaignBeaconController from "./campaign_beacon_controller"
application.register("campaign-beacon", CampaignBeaconController)

import SurveyQuestionController from "./survey_question_controller"
application.register("survey-question", SurveyQuestionController)
